import React from 'react'
import { cn } from '@/utils/cn'
import { MetricCard, MetricCardProps } from './MetricCard'

interface MetricGridProps {
  metrics: MetricCardProps[]
  columns?: 1 | 2 | 3 | 4
  className?: string
  title?: string
  subtitle?: string
}

export function MetricGrid({
  metrics,
  columns = 3,
  className,
  title,
  subtitle
}: MetricGridProps) {
  const gridClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  }

  return (
    <div className={cn("space-y-6", className)}>
      {(title || subtitle) && (
        <div className="text-center">
          {title && (
            <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
          )}
          {subtitle && (
            <p className="text-gray-600 max-w-2xl mx-auto">{subtitle}</p>
          )}
        </div>
      )}

      <div className={cn(
        "grid gap-6",
        gridClasses[columns]
      )}>
        {metrics.map((metric, index) => (
          <MetricCard
            key={`${metric.title}-${index}`}
            {...metric}
          />
        ))}
      </div>
    </div>
  )
}

// Metric category sections for organized display
interface MetricSectionProps {
  title: string
  subtitle?: string
  metrics: MetricCardProps[]
  columns?: 1 | 2 | 3 | 4
  className?: string
}

export function MetricSection({
  title,
  subtitle,
  metrics,
  columns = 3,
  className
}: MetricSectionProps) {
  return (
    <div className={cn("bg-white rounded-lg shadow border p-6", className)}>
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
        {subtitle && (
          <p className="text-sm text-gray-600">{subtitle}</p>
        )}
      </div>

      <MetricGrid
        metrics={metrics}
        columns={columns}
      />
    </div>
  )
}